import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useMetaBusinessManagerStore = defineStore({
  id: 'businessManagerStore',
  state: () => ({
    facebookBusinessManagers: [],
    facebookBusinessManagersLoading: false,
    error: null,
  }),
  getters: {},
  actions: {
    async getFacebookBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.facebookBusinessManagersLoading = true
      try {
        const {data} = await axios.get('facebook/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.facebookBusinessManagers = data.data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.facebookBusinessManagersLoading = false
      }
    },
    async getFacebookBusinessManagerSharedEmails(hash) {
      const {data} = await axios.get(`facebook/business-managers/${hash}/shared-emails`)

      return data
    },
  },
})
